import React from 'react';
import styles from './SuggestedTopics.module.scss';
import { Topic } from '../../../Models';
import { LinkList } from '../../../Components/LinkList/LinkList';
import { LinkListElement } from '../../../Components/LinkList/LinkListElement/LinkListElement';

export interface SuggestedTopicsProps {
  topics: Topic[];
}

export const SuggestedTopics = ({
  topics
}: SuggestedTopicsProps): React.ReactElement<SuggestedTopicsProps> => {
  return (
    <LinkList className={styles.suggestedTopics}>
      {topics.map((topic: Topic) => (
        <LinkListElement
          key={topic.id}
          to={`/topic/${topic.id}`}
          label={topic.name}
        />
      ))}
    </LinkList>
  );
};
